'use client';

import type { FC } from 'react';

import type { Product } from '@hyex/dxp/types/store/Product/Product';

import AddCartButton from '@hyex/modules/shared/base/AddCartButton';
import SmartLink from '@hyex/modules/shared/base/Link';
import ProductDescription from '@hyex/modules/shared/Product/common/ProductDescription';
import ProductImage from '@hyex/modules/shared/Product/common/ProductImage';
import ProductPrice from '@hyex/modules/shared/Product/common/ProductPrice';
import { ProductVariantType } from '@hyex/dxp/types/domain/ProductVariantType';
import { NextPage } from 'next';

type PropTypes = {
  item: Product;
  className?: string;
  addToCart?: any;
  defaultProductVariant?: ProductVariantType;
  storePath: string;
};

const ArticleProduct: NextPage<PropTypes> = ({
  item,
  className,
  addToCart,
  defaultProductVariant,
  storePath,
}) => {
  const redirectTo = `/${storePath}/${item.sku}`;

  return (
    <div className={className}>
      <ProductImage
        sku={item.sku}
        onSale={item?.isOnSale ?? false}
        image={item?.images?.single ?? ''}
        withBadge={false}
        withLink={!!item.sku}
        alt={item.title}
      />

      <div className="product-details">
        <h3>
          <SmartLink
            category={{
              path: redirectTo,
            }}
            isMobile={false}
            text={item.title}
            className="product-name"
          />
        </h3>
        <ProductDescription
          description={item.description}
          shortDescription={item?.shortDescription ?? ''}
        />
        <ProductPrice onSale={item?.isOnSale ?? false} price={item.price} salePrice={item.price} />
        <AddCartButton
          text={item?.isOutOfStock === true ? 'Sold Out' : 'Purchase'}
          className="cart-btn colored redirect_button"
          disabled={item?.isOutOfStock === true}
          redirectTo={redirectTo}
        />
      </div>
    </div>
  );
};

export default ArticleProduct;
